import { memo } from 'react'
import styled from 'styled-components'
import { TouchableNoFeedback } from '../../../elements/controls'
import { cursorPointer } from '../../../style/webStyles'
import { PortraitFeatured } from '../../content/PortraitFeatured/PortraitFeatured'

const calcHeight = (width, theme) => {
  const gutter = theme.spacing.sm
  return PortraitFeatured.calcHeight(width - gutter) + gutter
}

const Touchable = styled(TouchableNoFeedback)`
  padding-left: ${(props) => props.theme.spacing.sm / 2}px;
  padding-right: ${(props) => props.theme.spacing.sm / 2}px;
  padding-bottom: ${(props) => props.theme.spacing.sm}px;
  ${cursorPointer};
`

export const PortraitFeaturedContent = memo(({ item, theme, width, onChosen, ...props }) => (
  <Touchable onPress={() => onChosen(item)}>
    <PortraitFeatured {...props} item={item} width={width - theme.spacing.sm} />
  </Touchable>
))

PortraitFeaturedContent.calcHeight = calcHeight
